<section class="rd" [attr.aria-busy]="submitting">
  <header class="rd__header">
    <h3 class="rd__title">
      <i class="fa-solid fa-gavel rd__title-icon" aria-hidden="true"></i>
      {{ 'REVIEW_QUEUE.DECISION_TITLE' | translate }}
    </h3>
    <p class="rd__subtitle">{{ 'REVIEW_QUEUE.DECISION_SUBTITLE' | translate }}</p>
  </header>

  <label class="rd__label" for="rq-review-comment">
    {{ 'REVIEW_QUEUE.COMMENT_LABEL' | translate }}
  </label>

  <textarea
    #commentField
    id="rq-review-comment"
    class="form-control rd__comment"
    rows="3"
    [value]="comment()"
    [disabled]="submitting"
    [class.rd__comment--invalid]="rejectAttempted() && !canReject()"
    [attr.placeholder]="'REVIEW_QUEUE.COMMENT_PLACEHOLDER' | translate"
    (input)="onCommentInput($event)"
  ></textarea>

  @if (rejectAttempted() && !canReject()) {
    <p class="rd__error" role="alert">
      <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
      {{ 'REVIEW_QUEUE.REJECT_REASON_REQUIRED' | translate }}
    </p>
  } @else {
    <p class="rd__note">
      <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
      {{ 'REVIEW_QUEUE.REJECT_REASON_HINT' | translate }}
    </p>
  }

  <div class="rd__actions">
    <button
      type="button"
      class="rd__btn rd__btn--approve"
      [disabled]="submitting || !question"
      (click)="onApprove()"
    >
      <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
      <span>{{ 'REVIEW_QUEUE.APPROVE' | translate }}</span>
      <kbd class="rd__kbd">A</kbd>
    </button>

    <button
      type="button"
      class="rd__btn rd__btn--reject"
      [disabled]="submitting || !question || !canReject()"
      [attr.title]="
        canReject()
          ? null
          : ('REVIEW_QUEUE.REJECT_REASON_REQUIRED' | translate)
      "
      (click)="onReject()"
    >
      <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
      <span>{{ 'REVIEW_QUEUE.REJECT' | translate }}</span>
      <kbd class="rd__kbd">R</kbd>
    </button>
  </div>

  @if (submitting) {
    <p class="rd__pending">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ 'REVIEW_QUEUE.SUBMITTING' | translate }}
    </p>
  }
</section>
